// extracted by mini-css-extract-plugin
export default {"widget":"Widget_widget__yF9T-","small":"Widget_small__HFxfp","medium":"Widget_medium__xie8m","large":"Widget_large__mgMbw"};